// The selected tenant lives in web storage because the browser cannot read the
// httpOnly access token, so it cannot decode a default tenant out of the JWT
// claims. Until one is explicitly selected the Autar API applies its own
// DEFAULT_TENANT_ID.
//
// This sits under api-client rather than beside the rest of the session helpers
// so buildHeaders can reach it: lib/client/session imports apiFetch, and
// importing it back would be a cycle.
// Bumped from _v1: that key held a *fleet* id, written by a fleet selector that
// no longer exists. Reading it back would send a fleet id as the isolation
// boundary on every request a returning browser makes, indefinitely.
const TENANT_STORAGE_KEY = "client_selected_tenant_v2";

export const TENANT_HEADER_NAME = "x-tenant-id";

export function readStoredTenantId(): string | null {
  try {
    return window.localStorage.getItem(TENANT_STORAGE_KEY);
  } catch {
    return null;
  }
}

export function clearStoredTenantId(): void {
  try {
    window.localStorage.removeItem(TENANT_STORAGE_KEY);
  } catch {
    // ignore storage failures (private browsing, quota)
  }
}
